import AzureSearchApiSettings from './azuresearch.apisettings';
import AzureSearchGui from './azuresearch.searchgui';
import AzureSearchRequest from './azuresearch.searchrequest';

export default class AzureSearchSearchSettings {
  constructor(settings) {
    this.apiSettings = new AzureSearchApiSettings();
    this.gui = new AzureSearchGui();
    this.searchRequest = new AzureSearchRequest();
    this.facets = [];
    if (settings) {
      if (settings.apiSettings) this.apiSettings = settings.apiSettings;
      if (settings.gui) this.gui = settings.gui;
      if (settings.searchRequest) this.searchRequest = settings.searchRequest;
      if (settings.facets) this.facets = settings.facets;
    }
  }
}
